var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8765 13.4735H10.0432V10.1401H9.20988M10.0432 6.8068H10.0515M17.5432 10.1401C17.5432 11.1251 17.3492 12.1003 16.9723 13.0103C16.5954 13.9202 16.043 14.747 15.3465 15.4434C14.6501 16.1399 13.8233 16.6923 12.9133 17.0692C12.0034 17.4461 11.0281 17.6401 10.0432 17.6401C9.0583 17.6401 8.08303 17.4461 7.17309 17.0692C6.26315 16.6923 5.43635 16.1399 4.73991 15.4434C4.04347 14.747 3.49103 13.9202 3.11412 13.0103C2.73721 12.1003 2.54321 11.1251 2.54321 10.1401C2.54321 8.15101 3.33339 6.24336 4.73991 4.83684C6.14643 3.43031 8.05409 2.64014 10.0432 2.64014C12.0323 2.64014 13.94 3.43031 15.3465 4.83684C16.753 6.24336 17.5432 8.15101 17.5432 10.1401Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.500d36712d995aa33e65045052e28c01.svg";
export { ForwardRef as ReactComponent };